import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import QuoteForm from "@/components/QuoteForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import CookieBanner from "@/components/CookieBanner";
import CarpenteriaShowcase from "@/components/CarpenteriaShowcase";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#050B14] text-slate-50">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <CarpenteriaShowcase />
        <Stats />
        <Gallery />
        <Testimonials />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
    </div>
  );
}
